export const sortSectionEntries = ([_idA, a], [_idB, b]) => a?.order - b?.order;
